import React__default, { memo } from 'react';
import cn from 'classnames';
import { useTranslate } from '@awardit/react-use-translate';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { Button } from '../Button/index.js';
import { useDevice } from '../../utils.js';
import { Carousel } from '../Carousel/index.js';
import { Dots } from '../Carousel/controls.js';
import { Square } from '../Square/index.js';
import styles from 'ui-components/ProductViewMedia.scss';
import { ProductImage } from './image.js';
import { useBrowser } from '@awardit/react-use-browser';

var _excluded = ["location", "gallery", "alt", "currentImage", "setLightboxImage", "setOpen", "galleryPerRow", "galleryLocation"];
var galleryStaggerDelay = parseInt(styles.galleryStaggerDelay, 10);
var Media = function Media(_ref) {
  var location = _ref.location,
    gallery = _ref.gallery,
    alt = _ref.alt,
    currentImage = _ref.currentImage,
    setLightboxImage = _ref.setLightboxImage,
    setOpen = _ref.setOpen,
    _ref$galleryPerRow = _ref.galleryPerRow,
    galleryPerRow = _ref$galleryPerRow === void 0 ? 2 : _ref$galleryPerRow,
    _ref$galleryLocation = _ref.galleryLocation,
    galleryLocation = _ref$galleryLocation === void 0 ? "bottom" : _ref$galleryLocation,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var t = useTranslate();
  var state = location.state;
  var browser = useBrowser();
  var isDesktop = useDevice("gt", parseInt(styles.breakpoint, 10)) || !browser;
  var hintImage = browser ? state && state.hint && state.hint.image : null;
  if (isDesktop || (gallery == null ? void 0 : gallery.length) === 0) {
    return /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
      className: cn(styles.block, styles["block__" + galleryLocation])
    }), /*#__PURE__*/React__default.createElement(ProductImage, {
      image: currentImage,
      alt: alt,
      hintImage: hintImage,
      className: styles.image,
      style: {
        cursor: "zoom-in"
      },
      onClick: function onClick() {
        if (isDesktop) {
          setLightboxImage({
            tinyImage: currentImage.tinyImage ? {
              x1: currentImage.tinyImage.x1,
              x2: currentImage.tinyImage.x2
            } : null,
            smallImage: currentImage.smallImage ? {
              x1: currentImage.smallImage.x1,
              x2: currentImage.smallImage.x2
            } : null,
            mediumImage: currentImage.mediumImage ? {
              x1: currentImage.mediumImage.x1,
              x2: currentImage.mediumImage.x2
            } : null,
            largeImage: currentImage.largeImage ? {
              x1: currentImage.largeImage.x1,
              x2: currentImage.largeImage.x2
            } : null
          });
          setOpen(true);
        }
      }
    }), !isDesktop && /*#__PURE__*/React__default.createElement("div", {
      className: styles.carouselControls
    }), gallery && /*#__PURE__*/React__default.createElement("div", {
      className: cn(styles.gallery, [styles["gallery__perRow_" + galleryPerRow]])
    }, gallery.map(function (x, i) {
      var _x$thumb, _x$largeImage, _currentImage$largeIm, _cn;
      return /*#__PURE__*/React__default.createElement(Button, {
        key: (_x$thumb = x.thumb) == null ? void 0 : _x$thumb.x1,
        "aria-label": t("PRODUCT.CHANGE_IMAGE"),
        className: cn(styles.galleryItem, (_cn = {}, _cn[styles.active] = ((_x$largeImage = x.largeImage) == null ? void 0 : _x$largeImage.x1) === ((_currentImage$largeIm = currentImage.largeImage) == null ? void 0 : _currentImage$largeIm.x1), _cn)),
        style: {
          animationDelay: galleryStaggerDelay * i + "ms"
        },
        onClick: function onClick() {
          if (isDesktop) {
            setLightboxImage({
              tinyImage: x.tinyImage ? {
                x1: x.tinyImage.x1,
                x2: x.tinyImage.x2
              } : null,
              smallImage: x.smallImage ? {
                x1: x.smallImage.x1,
                x2: x.smallImage.x2
              } : null,
              mediumImage: x.mediumImage ? {
                x1: x.mediumImage.x1,
                x2: x.mediumImage.x2
              } : null,
              largeImage: x.largeImage ? {
                x1: x.largeImage.x1,
                x2: x.largeImage.x2
              } : null
            });
            setOpen(true);
          }
        }
      }, /*#__PURE__*/React__default.createElement("span", null, x.thumb && /*#__PURE__*/React__default.createElement("picture", null, /*#__PURE__*/React__default.createElement("source", {
        srcSet: x.thumb.x1 + " 1x, " + x.thumb.x2 + " 2x"
      }), /*#__PURE__*/React__default.createElement("img", {
        alt: alt,
        src: x.thumb.x1
      }))));
    })));
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
    className: styles.block
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.carousel
  }, /*#__PURE__*/React__default.createElement(Carousel, {
    slidesToScroll: 1,
    items: (gallery || []).map(function (g) {
      var _g$smallImage, _g$smallImage2;
      return /*#__PURE__*/React__default.createElement("div", {
        key: (_g$smallImage = g.smallImage) == null ? void 0 : _g$smallImage.x1
      }, /*#__PURE__*/React__default.createElement("picture", {
        className: styles.carouselPicture
      }, g.smallImage && /*#__PURE__*/React__default.createElement("source", {
        srcSet: g.smallImage.x1 + ", " + g.smallImage.x2 + " 2x",
        media: "(max-width: " + (Number.parseInt(styles.breakpoint, 10) - 1) + "px)"
      }), g.largeImage && /*#__PURE__*/React__default.createElement("source", {
        srcSet: g.largeImage.x1 + ", " + g.largeImage.x2 + " 2x",
        media: "(min-width: " + styles.breakpoint + "px)"
      }), /*#__PURE__*/React__default.createElement("img", {
        alt: alt,
        src: (_g$smallImage2 = g.smallImage) == null ? void 0 : _g$smallImage2.x2
      })), /*#__PURE__*/React__default.createElement(Square, null));
    })
  }, gallery && gallery.length > 1 ? /*#__PURE__*/React__default.createElement(Dots, {
    className: styles.carouselControls
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: styles.carouselControls
  }))));
};
var ProductViewImage = /*#__PURE__*/memo(Media);

export default ProductViewImage;
//# sourceMappingURL=media.js.map
